import { Link } from "react-router-dom";
import type { GatedSite } from "../../api/routing";
import { StatusChip } from "../../components/ui";

/** The PM42 jobs the scheduling gate leaves out of a plan, each with why:
 * under the count before planning, and under the proposal after it. Nothing
 * at all while the gate is off or holds nobody. Each name opens the site's
 * Readiness tab (Task 19 reads `?tab=readiness`). "PM42 by default" marks a job
 * whose work order type nobody has stated; the office can set it to PM41 there,
 * which takes it out of the gate. */
export default function GatedNote({ sites, total }: { sites: readonly GatedSite[] | undefined; total?: number }) {
  if (sites === undefined || sites.length === 0) {
    return null;
  }
  const count = total ?? sites.length;
  return (
    <details className="planner-gated notice warn">
      <summary>Not ready to schedule ({count})</summary>
      <ul>
        {sites.map((site) => (
          <li key={site.site_id}>
            <Link to={`/sites/${site.site_id}?tab=readiness`}>{site.name}</Link>{" "}
            {site.basis === "default" ? <StatusChip tone="quiet">PM42 by default</StatusChip> : null}{" "}
            {site.reasons.map((reason) => (
              <StatusChip key={reason} tone="warn">
                {reason}
              </StatusChip>
            ))}
          </li>
        ))}
      </ul>
      {count > sites.length ? <p>The first {sites.length} are listed.</p> : null}
    </details>
  );
}
